import React from "react";

import { Category, Option } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";

import useOrderOptions from "../../../../../../../../../components/Orders/getOrderOptions";
import { useAppState } from "../../../../../../../../../context/StateContext";
import { PurchaseOrder } from "../../../../../../../../../models/purchase.order";
import { Supplier } from "../../../../../../../../../models/supplier";
import PurchaseOrderService from "../../../../../../../../../services/purchase.order.service";
import SupplierService from "../../../../../../../../../services/supplier.service";
import { ColumnWithKey } from "../../../../../../../../../types";
import { OrderDetailsFields } from "../../../../../../../../../util/enums";
import { useActionReportMaintenance } from "../../../hooks/useAction";
import { useReportState } from "../../../hooks/useReportState";
import { convertValueToSearch } from "../../../utils";
import { BaseReportGrid } from "../../BaseReportGrid";

export const FinancialsReport = () => {
  const { getBookingInvoiceList } = useActionReportMaintenance();
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();
  const { orderTypes, incotermOptions, modeOptions } = useOrderOptions();
  const {
    filters,
    setFilters,
    tempFilters,
    setTempFilters,
    allCurrentFilters,
    dateFilters,
    setDateFilters,
    type,
  } = useReportState(false);

  const filterCategories: Category[] = [
    // {
    //   name: `${translate("order")} #`,
    //   column: "invoiceReports.poNumber",
    //   onSearch: (value: string) =>
    //     PurchaseOrderService.getAllNetwork({
    //       group: ["purchase_order.id"],
    //       companyId: currentUser?.companyId,
    //       include: JSON.stringify([]),
    //       attributes: ["id", "reference"],
    //       searchByOr: JSON.stringify(convertValueToSearch(value, "purchase_order_id")),
    //     }),
    //   getOptionLabel: (option: PurchaseOrder) => option?.reference || "",
    // },
    {
      name: translate("mode"),
      column: "shipmentType",
      options: modeOptions,
      getOptionLabel: (option: Option) => option?.label || "",
      optionColumn: "value",
    },
    {
      name: translate("incoterm"),
      column: "incoterm",
      options: incotermOptions,
      getOptionLabel: (option: Option) => option?.label || "",
      optionColumn: "value",
    },
    // {
    //   name: translate("supplier"),
    //   column: "company.supplierAssociated.id",
    //   onSearch: (value: string) =>
    //     SupplierService.getAll({
    //       searchByOr: JSON.stringify(convertValueToSearch(value, "name")),
    //       attributes: ["id", "name", "associatedCompanyId"],
    //       isCompany: true,
    //     }),
    //   getOptionLabel: (option: Supplier) => option?.name || "",
    //   optionColumn: "associatedCompanyId",
    // },
  ];

  const columns: ColumnWithKey[] = [
    {
      name: "commercialInvoice.invoiceNumber",
      title: translate("invoiceNo"),
    },
    {
      name: "submissionDate",
      title: translate("invoiceDate"),
    },
    {
      name: "receivedDate",
      title: translate("receivedDate"),
    },
    {
      name: "commercialInvoice.vendorId",
      title: translate("vendorId"),
    },
    {
      name: "company.supplierAssociated.name",
      title: translate("supplier"),
    },
    {
      name: "invoiceReports.poNumber",
      title: translate("poNumber"),
    },
    {
      name: "invoiceReports.addressCode",
      title: translate("addressCode"),
    },
    {
      name: "invoiceReports.sku",
      title: translate("sku"),
    },
    {
      name: "invoiceReports.currency",
      title: translate("currency"),
    },
    {
      name: "invoiceReports.purchasePrice",
      title: translate("unitPrice"),
    },
    {
      name: "invoiceReports.quantity",
      title: translate("unitQty"),
    },
    {
      name: "invoiceReports.totalPrice",
      title: translate("total"),
    },
    {
      name: "invoiceReports.invoiceTotal",
      title: translate("invoiceTotal"),
    },
  ];

  const getResourcesPerReport = () => {
    switch (type) {
      default:
        return {
          keyExtractor: (data: any) => data["invoiceReports.id"],
          query: getBookingInvoiceList,
          columns,
        };
    }
  };

  return (
    <BaseReportGrid
      keyExtractor={getResourcesPerReport().keyExtractor}
      getAllData={getResourcesPerReport().query}
      columns={getResourcesPerReport().columns}
      dateFilters={dateFilters}
      setDateFilters={setDateFilters}
      filterCategories={filterCategories}
      filters={filters}
      setFilters={setFilters}
      tempFilters={tempFilters}
      setTempFilters={setTempFilters}
      allCurrentFilters={allCurrentFilters}
      isDataLocal={false}
      showSendMail
    />
  );
};
